import React, { forwardRef, useRef, useState, useMemo } from 'react'
import MaterialTable from '@material-table/core'
import {
  Edit,
  Delete,
  Search,
  ChevronLeft,
  ChevronRight,
  FirstPage,
  LastPage,
  ArrowDownward,
  Add,
  Clear,
  Check,
} from '@material-ui/icons'
import { Paper } from '@material-ui/core'

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import MTableBody from './MTableBody'
import MTableBodyRow from './MTableBodyRow'

const TableContainer = (props) => (
  <Paper
    {...props}
    elevation={0}
    style={{ color: '#000', ...(props.style || {}) }}
  />
)

const DataTable = ({
  name,
  columns = [],
  components = {},
  options = {},
  onChangeRowsPerPage,
  onChangeDrag,
  tableIcon,
  ...props
}) => {
  const tableIcons = {
    Add: forwardRef((props, ref) => <Add {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <Delete {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
      <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => (
      <ArrowDownward {...props} ref={ref} />
    )),
    DetailPanel: forwardRef((props, ref) => (
      <ChevronRight {...props} ref={ref} />
    )),
    ...tableIcon,
  }

  const tableRef = useRef(null)
  const localRef = props.tableRef || tableRef

  const [pageSize, setPageSize] = useState(options.pageSize ?? 5)

  useMemo(() => {
    if (options.pageSize) {
      setPageSize(options.pageSize)
    }
  }, [options.pageSize])

  const onDragEnd = (result) => {
    const { destination, source } = result
    if (!destination) return
    if (source.index !== destination.index) {
      let copyArray = [...props.data]
      let temp = props.data[source.index]

      copyArray.splice(source.index, 1)
      copyArray.splice(destination.index, 0, temp)

      if (onChangeDrag) {
        onChangeDrag(copyArray)
      }
    }
  }

  const componentsForDrag = onChangeDrag && {
    Body: (props) => (
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId={'singleColumnDroppableAreaThusStaticInput'}>
          {(provided) => (
            <>
              <MTableBody {...props} forwardedRef={provided.innerRef} />
              {provided.placeholder}
            </>
          )}
        </Droppable>
      </DragDropContext>
    ),
    Row: (props) => (
      <Draggable
        draggableId={props.data.tableData.id.toString()}
        index={props.data.tableData.id}
      >
        {(provided) => {
          return (
            <MTableBodyRow
              {...props}
              {...provided.draggableProps}
              // {...provided.dragHandleProps}
              forwardedRef={provided.innerRef}
              dragHandleProps={provided.dragHandleProps}
            />
          )
        }}
      </Draggable>
    ),
  }

  const dragColumn = {
    isDrag: true,
    editable: 'never',
    sorting: false,
    headerStyle: {
      width: 10,
      maxWidth: 10,
      padding: '0 10px',
    },
  }

  return (
    <div>
      <MaterialTable
        tableRef={localRef}
        columns={onChangeDrag ? [dragColumn, ...columns] : columns}
        onChangeRowsPerPage={
          onChangeRowsPerPage
            ? onChangeRowsPerPage
            : (perPage) => setPageSize(perPage)
        }
        options={{
          ...options,
          pageSize: pageSize,
        }}
        components={{
          Container: TableContainer,
          ...componentsForDrag,
          ...components,
        }}
        icons={tableIcons}
        {...props}
      />
    </div>
  )
}

export default DataTable
